<header class="relative px-4 pb-4 pt-2">
  <h1 class="text-2xl font-semibold text-greyscale-900">Contributions</h1>
  <p class="text-sm text-greyscale-600">Manage all user contributions across all companies</p>
</header>

<main class="p-4">
  <p-table
    [value]="contributions"
    [paginator]="false"
    styleClass="p-datatable-sm"
  >
    <ng-template #caption>
      <div class="flex flex-wrap items-end gap-4">
        <div class="min-w-[150px]">
          <span class="mb-1 block text-sm font-medium">Status</span>
          <p-select
            [options]="statusOptions"
            [(ngModel)]="statusFilter"
            (onChange)="onFilterChange()"
            optionLabel="label"
            optionValue="value"
            placeholder="All statuses"
            [style]="{ width: '100%' }"
          />
        </div>
        <div class="min-w-[140px]">
          <span class="mb-1 block text-sm font-medium">Payment</span>
          <p-select
            [options]="paymentMethodOptions"
            [(ngModel)]="paymentMethodFilter"
            (onChange)="onFilterChange()"
            optionLabel="label"
            optionValue="value"
            placeholder="All methods"
            [style]="{ width: '100%' }"
          />
        </div>
        <div class="min-w-[140px]">
          <span class="mb-1 block text-sm font-medium">From</span>
          <p-calendar
            [(ngModel)]="startDate"
            (onSelect)="onFilterChange()"
            (onClear)="onFilterChange()"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            [showClear]="true"
            placeholder="Select date..."
            [style]="{ width: '100%' }"
          />
        </div>
        <div class="min-w-[140px]">
          <span class="mb-1 block text-sm font-medium">To</span>
          <p-calendar
            [(ngModel)]="endDate"
            (onSelect)="onFilterChange()"
            (onClear)="onFilterChange()"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            [showClear]="true"
            placeholder="Select date..."
            [style]="{ width: '100%' }"
          />
        </div>
        <div>
          <p-button
            icon="pi pi-filter-slash"
            (onClick)="resetFilters()"
            [text]="true"
            [rounded]="true"
            pTooltip="Reset filters"
          />
        </div>
        <div class="ml-auto min-w-[200px]">
          <span class="mb-1 block text-sm font-medium">Search</span>
          <p-iconfield iconPosition="left">
            <p-inputicon>
              <i class="pi pi-search"></i>
            </p-inputicon>
            <input
              pInputText
              type="text"
              [(ngModel)]="searchText"
              (ngModelChange)="onSearchChange()"
              placeholder="Search contributions..."
              class="w-full"
            />
          </p-iconfield>
        </div>
      </div>
    </ng-template>
    <ng-template #header>
      <tr>
        <th>Date</th>
        <th>Company / User</th>
        <th>Trip</th>
        <th>CO2</th>
        <th>Amount</th>
        <th>Status</th>
      </tr>
    </ng-template>

    <ng-template #body let-contribution>
      <tr
        class="cursor-pointer hover:bg-gray-50 h-14"
        (click)="viewDetails(contribution.id)"
      >
        <!-- Date -->
        <td>{{ formatDate(contribution.createdAt) }}</td>

        <!-- Company / User -->
        <td>
          <div class="font-medium">{{ contribution.company.name }}</div>
          <div class="text-xs text-gray-500">
            {{ contribution.user.firstName }} {{ contribution.user.lastName }}
          </div>
        </td>

        <!-- Trip -->
        <td>
          <div
            [pTooltip]="contribution.trip.title"
            class="max-w-[200px] truncate"
          >
            {{ contribution.trip.title }}
          </div>
        </td>

        <!-- CO2 -->
        <td class="font-medium">{{ getTotalCO2(contribution).toFixed(0) }} kg</td>

        <!-- Amount -->
        <td class="font-medium">{{ formatAmount(contribution.totalAmount) }}</td>

        <!-- Status -->
        <td>
          <span
            class="px-2 py-1 rounded-full text-xs font-medium whitespace-nowrap"
            [ngClass]="getStatusClasses(contribution.status)"
          >
            {{ getStatusLabel(contribution.status) }}
          </span>
        </td>
      </tr>
    </ng-template>

    <ng-template #emptymessage>
      <tr>
        <td colspan="6" class="text-center py-12">
          <i class="pi pi-inbox text-4xl text-gray-400 mb-4"></i>
          <p class="text-gray-500">No contributions found</p>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- Custom Pagination -->
  <div class="flex items-center justify-between mt-4">
    <div class="flex items-center gap-2">
      <span class="text-sm text-gray-600">Items per page:</span>
      <p-select
        [options]="pageSizeOptions"
        [(ngModel)]="pageSize"
        (onChange)="onPageSizeChange()"
        optionLabel="label"
        optionValue="value"
        [style]="{ width: '80px' }"
      />
      <span class="text-sm text-gray-600 ml-4">
        Total: {{ totalRecords }} contribution(s)
      </span>
    </div>

    <div class="flex items-center gap-2">
      <p-button
        icon="pi pi-angle-left"
        (onClick)="onPageChange(currentPage - 1)"
        [disabled]="currentPage === 1"
        [text]="true"
      />

      <span class="text-sm text-gray-600">
        Page {{ currentPage }} of {{ totalPages }}
      </span>

      <p-button
        icon="pi pi-angle-right"
        (onClick)="onPageChange(currentPage + 1)"
        [disabled]="currentPage === totalPages"
        [text]="true"
      />
    </div>
  </div>
</main>

<p-toast />
<p-confirmDialog rejectButtonStyleClass="p-button-outlined" />
